// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "datamanagement/internalapi/v1/data.proto" (package "datamanagement.internalapi.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal and private data managment RPCs and protos
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { InternalDataService } from "./data";
import type { ListSequenceResourcesResponse } from "./data";
import type { ListSequenceResourcesRequest } from "./data";
import type { ListSequenceTagsResponse } from "./data";
import type { ListSequenceTagsRequest } from "./data";
import type { ListSequencesByFilterResponse } from "./data";
import type { ListSequencesByFilterRequest } from "./data";
import type { ListIndexesWithStatusResponse } from "./data";
import type { ListIndexesWithStatusRequest } from "./data";
import type { GetSequenceTabularDataResponse } from "./data";
import type { GetSequenceTabularDataRequest } from "./data";
import type { DeleteBinaryDataByExclusionFilterResponse } from "./data";
import type { DeleteBinaryDataByExclusionFilterRequest } from "./data";
import type { AddBinaryDataToDatasetByFilterResponse } from "./data";
import type { AddBinaryDataToDatasetByFilterRequest } from "./data";
import type { GetBinaryDataByExclusionFilterResponse } from "./data";
import type { GetBinaryDataByExclusionFilterRequest } from "./data";
import type { GetSensorPageUpdateResponse } from "./data";
import type { GetSensorPageUpdateRequest } from "./data";
import type { GetSensorPageDataResponse } from "./data";
import type { GetSensorPageDataRequest } from "./data";
import type { GetRecentDataStoreConfiguredResponse } from "./data";
import type { GetRecentDataStoreConfiguredRequest } from "./data";
import type { GetLatestTabularDataByPartIDResponse } from "./data";
import type { GetLatestTabularDataByPartIDRequest } from "./data";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetLatestBinaryDataByPartIDResponse } from "./data";
import type { GetLatestBinaryDataByPartIDRequest } from "./data";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service datamanagement.internalapi.v1.InternalDataService
 */
export interface IInternalDataServiceClient {
    /**
     * @generated from protobuf rpc: GetLatestBinaryDataByPartID(datamanagement.internalapi.v1.GetLatestBinaryDataByPartIDRequest) returns (datamanagement.internalapi.v1.GetLatestBinaryDataByPartIDResponse);
     */
    getLatestBinaryDataByPartID(input: GetLatestBinaryDataByPartIDRequest, options?: RpcOptions): UnaryCall<GetLatestBinaryDataByPartIDRequest, GetLatestBinaryDataByPartIDResponse>;
    /**
     * @generated from protobuf rpc: GetLatestTabularDataByPartID(datamanagement.internalapi.v1.GetLatestTabularDataByPartIDRequest) returns (datamanagement.internalapi.v1.GetLatestTabularDataByPartIDResponse);
     */
    getLatestTabularDataByPartID(input: GetLatestTabularDataByPartIDRequest, options?: RpcOptions): UnaryCall<GetLatestTabularDataByPartIDRequest, GetLatestTabularDataByPartIDResponse>;
    /**
     * @generated from protobuf rpc: GetRecentDataStoreConfigured(datamanagement.internalapi.v1.GetRecentDataStoreConfiguredRequest) returns (datamanagement.internalapi.v1.GetRecentDataStoreConfiguredResponse);
     */
    getRecentDataStoreConfigured(input: GetRecentDataStoreConfiguredRequest, options?: RpcOptions): UnaryCall<GetRecentDataStoreConfiguredRequest, GetRecentDataStoreConfiguredResponse>;
    /**
     * @generated from protobuf rpc: GetSensorPageData(datamanagement.internalapi.v1.GetSensorPageDataRequest) returns (datamanagement.internalapi.v1.GetSensorPageDataResponse);
     */
    getSensorPageData(input: GetSensorPageDataRequest, options?: RpcOptions): UnaryCall<GetSensorPageDataRequest, GetSensorPageDataResponse>;
    /**
     * @generated from protobuf rpc: GetSensorPageUpdate(datamanagement.internalapi.v1.GetSensorPageUpdateRequest) returns (datamanagement.internalapi.v1.GetSensorPageUpdateResponse);
     */
    getSensorPageUpdate(input: GetSensorPageUpdateRequest, options?: RpcOptions): UnaryCall<GetSensorPageUpdateRequest, GetSensorPageUpdateResponse>;
    /**
     * @generated from protobuf rpc: GetBinaryDataByExclusionFilter(datamanagement.internalapi.v1.GetBinaryDataByExclusionFilterRequest) returns (datamanagement.internalapi.v1.GetBinaryDataByExclusionFilterResponse);
     */
    getBinaryDataByExclusionFilter(input: GetBinaryDataByExclusionFilterRequest, options?: RpcOptions): UnaryCall<GetBinaryDataByExclusionFilterRequest, GetBinaryDataByExclusionFilterResponse>;
    /**
     * @generated from protobuf rpc: AddBinaryDataToDatasetByFilter(datamanagement.internalapi.v1.AddBinaryDataToDatasetByFilterRequest) returns (datamanagement.internalapi.v1.AddBinaryDataToDatasetByFilterResponse);
     */
    addBinaryDataToDatasetByFilter(input: AddBinaryDataToDatasetByFilterRequest, options?: RpcOptions): UnaryCall<AddBinaryDataToDatasetByFilterRequest, AddBinaryDataToDatasetByFilterResponse>;
    /**
     * @generated from protobuf rpc: DeleteBinaryDataByExclusionFilter(datamanagement.internalapi.v1.DeleteBinaryDataByExclusionFilterRequest) returns (datamanagement.internalapi.v1.DeleteBinaryDataByExclusionFilterResponse);
     */
    deleteBinaryDataByExclusionFilter(input: DeleteBinaryDataByExclusionFilterRequest, options?: RpcOptions): UnaryCall<DeleteBinaryDataByExclusionFilterRequest, DeleteBinaryDataByExclusionFilterResponse>;
    /**
     * @generated from protobuf rpc: GetSequenceTabularData(datamanagement.internalapi.v1.GetSequenceTabularDataRequest) returns (datamanagement.internalapi.v1.GetSequenceTabularDataResponse);
     */
    getSequenceTabularData(input: GetSequenceTabularDataRequest, options?: RpcOptions): UnaryCall<GetSequenceTabularDataRequest, GetSequenceTabularDataResponse>;
    /**
     * @generated from protobuf rpc: ListIndexesWithStatus(datamanagement.internalapi.v1.ListIndexesWithStatusRequest) returns (datamanagement.internalapi.v1.ListIndexesWithStatusResponse);
     */
    listIndexesWithStatus(input: ListIndexesWithStatusRequest, options?: RpcOptions): UnaryCall<ListIndexesWithStatusRequest, ListIndexesWithStatusResponse>;
    /**
     * ListSequencesByFilter is ListSequences with filtering. Results are sorted by start_time descending.
     *
     * @generated from protobuf rpc: ListSequencesByFilter(datamanagement.internalapi.v1.ListSequencesByFilterRequest) returns (datamanagement.internalapi.v1.ListSequencesByFilterResponse);
     */
    listSequencesByFilter(input: ListSequencesByFilterRequest, options?: RpcOptions): UnaryCall<ListSequencesByFilterRequest, ListSequencesByFilterResponse>;
    /**
     * ListSequenceTags returns the distinct tags on an org's sequences, sorted.
     *
     * @generated from protobuf rpc: ListSequenceTags(datamanagement.internalapi.v1.ListSequenceTagsRequest) returns (datamanagement.internalapi.v1.ListSequenceTagsResponse);
     */
    listSequenceTags(input: ListSequenceTagsRequest, options?: RpcOptions): UnaryCall<ListSequenceTagsRequest, ListSequenceTagsResponse>;
    /**
     * ListSequenceResources returns the distinct resources in an org's sequences, sorted by resource name then method name.
     *
     * @generated from protobuf rpc: ListSequenceResources(datamanagement.internalapi.v1.ListSequenceResourcesRequest) returns (datamanagement.internalapi.v1.ListSequenceResourcesResponse);
     */
    listSequenceResources(input: ListSequenceResourcesRequest, options?: RpcOptions): UnaryCall<ListSequenceResourcesRequest, ListSequenceResourcesResponse>;
}
/**
 * @generated from protobuf service datamanagement.internalapi.v1.InternalDataService
 */
export class InternalDataServiceClient implements IInternalDataServiceClient, ServiceInfo {
    typeName = InternalDataService.typeName;
    methods = InternalDataService.methods;
    options = InternalDataService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetLatestBinaryDataByPartID(datamanagement.internalapi.v1.GetLatestBinaryDataByPartIDRequest) returns (datamanagement.internalapi.v1.GetLatestBinaryDataByPartIDResponse);
     */
    getLatestBinaryDataByPartID(input: GetLatestBinaryDataByPartIDRequest, options?: RpcOptions): UnaryCall<GetLatestBinaryDataByPartIDRequest, GetLatestBinaryDataByPartIDResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetLatestBinaryDataByPartIDRequest, GetLatestBinaryDataByPartIDResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetLatestTabularDataByPartID(datamanagement.internalapi.v1.GetLatestTabularDataByPartIDRequest) returns (datamanagement.internalapi.v1.GetLatestTabularDataByPartIDResponse);
     */
    getLatestTabularDataByPartID(input: GetLatestTabularDataByPartIDRequest, options?: RpcOptions): UnaryCall<GetLatestTabularDataByPartIDRequest, GetLatestTabularDataByPartIDResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetLatestTabularDataByPartIDRequest, GetLatestTabularDataByPartIDResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetRecentDataStoreConfigured(datamanagement.internalapi.v1.GetRecentDataStoreConfiguredRequest) returns (datamanagement.internalapi.v1.GetRecentDataStoreConfiguredResponse);
     */
    getRecentDataStoreConfigured(input: GetRecentDataStoreConfiguredRequest, options?: RpcOptions): UnaryCall<GetRecentDataStoreConfiguredRequest, GetRecentDataStoreConfiguredResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRecentDataStoreConfiguredRequest, GetRecentDataStoreConfiguredResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetSensorPageData(datamanagement.internalapi.v1.GetSensorPageDataRequest) returns (datamanagement.internalapi.v1.GetSensorPageDataResponse);
     */
    getSensorPageData(input: GetSensorPageDataRequest, options?: RpcOptions): UnaryCall<GetSensorPageDataRequest, GetSensorPageDataResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetSensorPageDataRequest, GetSensorPageDataResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetSensorPageUpdate(datamanagement.internalapi.v1.GetSensorPageUpdateRequest) returns (datamanagement.internalapi.v1.GetSensorPageUpdateResponse);
     */
    getSensorPageUpdate(input: GetSensorPageUpdateRequest, options?: RpcOptions): UnaryCall<GetSensorPageUpdateRequest, GetSensorPageUpdateResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetSensorPageUpdateRequest, GetSensorPageUpdateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetBinaryDataByExclusionFilter(datamanagement.internalapi.v1.GetBinaryDataByExclusionFilterRequest) returns (datamanagement.internalapi.v1.GetBinaryDataByExclusionFilterResponse);
     */
    getBinaryDataByExclusionFilter(input: GetBinaryDataByExclusionFilterRequest, options?: RpcOptions): UnaryCall<GetBinaryDataByExclusionFilterRequest, GetBinaryDataByExclusionFilterResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetBinaryDataByExclusionFilterRequest, GetBinaryDataByExclusionFilterResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AddBinaryDataToDatasetByFilter(datamanagement.internalapi.v1.AddBinaryDataToDatasetByFilterRequest) returns (datamanagement.internalapi.v1.AddBinaryDataToDatasetByFilterResponse);
     */
    addBinaryDataToDatasetByFilter(input: AddBinaryDataToDatasetByFilterRequest, options?: RpcOptions): UnaryCall<AddBinaryDataToDatasetByFilterRequest, AddBinaryDataToDatasetByFilterResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddBinaryDataToDatasetByFilterRequest, AddBinaryDataToDatasetByFilterResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteBinaryDataByExclusionFilter(datamanagement.internalapi.v1.DeleteBinaryDataByExclusionFilterRequest) returns (datamanagement.internalapi.v1.DeleteBinaryDataByExclusionFilterResponse);
     */
    deleteBinaryDataByExclusionFilter(input: DeleteBinaryDataByExclusionFilterRequest, options?: RpcOptions): UnaryCall<DeleteBinaryDataByExclusionFilterRequest, DeleteBinaryDataByExclusionFilterResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteBinaryDataByExclusionFilterRequest, DeleteBinaryDataByExclusionFilterResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetSequenceTabularData(datamanagement.internalapi.v1.GetSequenceTabularDataRequest) returns (datamanagement.internalapi.v1.GetSequenceTabularDataResponse);
     */
    getSequenceTabularData(input: GetSequenceTabularDataRequest, options?: RpcOptions): UnaryCall<GetSequenceTabularDataRequest, GetSequenceTabularDataResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetSequenceTabularDataRequest, GetSequenceTabularDataResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListIndexesWithStatus(datamanagement.internalapi.v1.ListIndexesWithStatusRequest) returns (datamanagement.internalapi.v1.ListIndexesWithStatusResponse);
     */
    listIndexesWithStatus(input: ListIndexesWithStatusRequest, options?: RpcOptions): UnaryCall<ListIndexesWithStatusRequest, ListIndexesWithStatusResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListIndexesWithStatusRequest, ListIndexesWithStatusResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListSequencesByFilter is ListSequences with filtering. Results are sorted by start_time descending.
     *
     * @generated from protobuf rpc: ListSequencesByFilter(datamanagement.internalapi.v1.ListSequencesByFilterRequest) returns (datamanagement.internalapi.v1.ListSequencesByFilterResponse);
     */
    listSequencesByFilter(input: ListSequencesByFilterRequest, options?: RpcOptions): UnaryCall<ListSequencesByFilterRequest, ListSequencesByFilterResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListSequencesByFilterRequest, ListSequencesByFilterResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListSequenceTags returns the distinct tags on an org's sequences, sorted.
     *
     * @generated from protobuf rpc: ListSequenceTags(datamanagement.internalapi.v1.ListSequenceTagsRequest) returns (datamanagement.internalapi.v1.ListSequenceTagsResponse);
     */
    listSequenceTags(input: ListSequenceTagsRequest, options?: RpcOptions): UnaryCall<ListSequenceTagsRequest, ListSequenceTagsResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListSequenceTagsRequest, ListSequenceTagsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListSequenceResources returns the distinct resources in an org's sequences, sorted by resource name then method name.
     *
     * @generated from protobuf rpc: ListSequenceResources(datamanagement.internalapi.v1.ListSequenceResourcesRequest) returns (datamanagement.internalapi.v1.ListSequenceResourcesResponse);
     */
    listSequenceResources(input: ListSequenceResourcesRequest, options?: RpcOptions): UnaryCall<ListSequenceResourcesRequest, ListSequenceResourcesResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListSequenceResourcesRequest, ListSequenceResourcesResponse>("unary", this._transport, method, opt, input);
    }
}
